<template>
	<FloatingMessage title="Waiting for sample event…">
		<template v-slot:content>
			<div class="title-cont">
				{{
					hasParent
						? 'Go to a parent feature that triggers this subflow and click “send sample data to subflow”'
						: 'Connect parent feature to send sample data'
				}}
			</div>
			<div class="mt-4 event-description">The step will update once an event is received</div>
			<div class="display-flex flex-column flex-align-center mt-9">
				<div class="end-description">We'll wait for 5 minutes.</div>
				<div class="end-description">If it takes longer you can always click test again.</div>
			</div>
		</template>
		<template v-slot:bottom>
			<div @click="emitCancel" class="light-hover-effect">Cancel</div>
			<div class="display-flex flex-row mt-4 font-size-md text-align-center flex-centerize"></div>
		</template>
	</FloatingMessage>
</template>

<script>
import FloatingMessage from '../helpers/FloatingMessage';

export default {
	name: 'WaitingForSubflowTestFloatingMessage',
	components: {
		FloatingMessage,
	},
	props: {
		hasParent: { type: Boolean },
		cancelCallback: { type: Function, default: () => null },
	},
	methods: {
		emitCancel() {
			this.cancelCallback();
		},
	},
};
</script>
